<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fmtitle"><a id="h1">Contents</a></h2><a id="h1">
<p class="common"><img alt="images" src="images/common.jpg"/></p>
</a><p class="paraToc"><a id="h1"></a><a href="#/04_maps#h2">List of Maps</a></p>
<p class="paraToc"><a href="#/05_plates#h3">List of Plates</a></p>
<p class="paraToc"><a href="#/06_acknowledgements#h4">Acknowledgements</a></p>
<p class="paraToc1"><a href="#/07_contributors#h5">List of Contributors</a></p>
<p class="paraToc"><a href="#/08_introduction#h6">Introduction</a></p>
<p class="paraToc"><a href="#/09_chapter01#h7">Chapter 1 Garnet Wolseley – <em class="italic">by Steven J Corvi</em></a></p>
<p class="paraToc"><span href="#/12_chapter02#h8" title="Link target outside of Sample">Chapter 2 Evelyn Wood – <em class="italic">by Stephen Manning</em></span></p>
<p class="paraToc"><span href="#/15_chapter03#h9" title="Link target outside of Sample">Chapter 3 Redvers Buller – <em class="italic">by Stephen M Miller</em></span></p>
<p class="paraToc"><span href="#/18_chapter04#h10" title="Link target outside of Sample">Chapter 4 George Colley – <em class="italic">by Ian F W Beckett</em></span></p>
<p class="paraToc"><span href="#/33_chapter05#h11" title="Link target outside of Sample">Chapter 5 Lord Chelmsford – <em class="italic">by John Laband</em></span></p>
<p class="paraToc"><span href="#/36_chapter06#h12" title="Link target outside of Sample">Chapter 6 Charles Gordon – <em class="italic">by Gerald Herman</em></span></p>
<p class="paraToc"><span href="#/41_chapter07#h13" title="Link target outside of Sample">Chapter 7 Frederick Roberts – <em class="italic">by André Wessels</em></span></p>
<p class="paraToc1"><span href="#/48_chapter08#h14" title="Link target outside of Sample">Chapter 8 Herbert Kitchener – <em class="italic">by Keith Surridge</em></span></p>
<p class="paraToc"><span href="#/55_appendix#h15" title="Link target outside of Sample">Appendix Chronology of Victorian Wars</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_contents.vue?02a362c8